import useUser from '../hooks/global/useUser';
import { isUserEmployeeOrAdmin } from '../utils/global/helper';
import PageLayout from '../components/global/PageLayout';
import useCleanParam from '../hooks/useCleanParam';
import { URL_FRIENDLY } from '../constants/regex';
import useWaiverRequest from '../hooks/waivers/useWaiverRequest';
import PageLoading from '../components/global/PageLoading';
import Error from '../components/global/Error';
import WaiverRequestView from '../components/waivers/WaiverRequestView';

export default function EmployeeWaiverPage() {
  const { user } = useUser();
  const waiverRequestId = useCleanParam({
    key: 'waiverRequestId',
    regex: URL_FRIENDLY,
  });
  const { data, isLoading } = useWaiverRequest({
    waiverRequestId,
  });
  const { waiverRequest, waiver } = data ?? {};

  const waiverExists = !!waiverRequest && !!waiver;

  const isSigned = waiverRequest?.status === 'SIGNED';
  const isValid =
    !!waiverRequest && isSigned && !!waiverRequest.signedFileLink && !!waiver;

  const errorMessage = !waiverExists
    ? 'This waiver does not exist'
    : !isSigned
    ? 'This waiver has not been completed by the customer'
    : '';
  const errorDescription = !waiverExists
    ? 'Please contact support if you believe this is an error.'
    : !isSigned
    ? 'You cannot view the waiver until the customer completes it. Please contact support if you believe this is an error.'
    : undefined;

  return (
    <PageLayout
      guard={{
        isAllowed: !!user && isUserEmployeeOrAdmin(user),
      }}>
      {isLoading && <PageLoading />}
      {isValid && !isLoading && (
        <WaiverRequestView waiverRequestId={waiverRequestId!} />
      )}
      {!isValid && !isLoading && (
        <Error
          errorMessage={errorMessage}
          description={errorDescription}
          logOut={false}
        />
      )}
    </PageLayout>
  );
}
